import React from "react";
import PropTypes from "prop-types";

import BalloonString from "./BalloonString";

const BalloonAvatar = ({ avatarName }) => {
    return (
        <div className="balloon-avatar">
            <div className="balloon-avatar__image">
                <img
                    src={require(`../../imgs/avatar-${avatarName}.png`)}
                    alt={`icon of ${avatarName}`}
                />
            </div>
            <BalloonString balloonClass="balloon-avatar__string" />
            <p className="balloon-avatar__name">{avatarName}</p>
        </div>
    );
};

BalloonAvatar.propTypes = {
    avatarName: PropTypes.string.isRequired
};

export default BalloonAvatar;



// WEBPACK FOOTER //
// ./src/components/landingPage/BalloonAvatar.jsx